import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ResponseModel } from 'src/app/shared/models/response.model';
import { PqrLanguageEntity } from '../entities/pqrLanguage.entity';
import { PqrFormLawEntity } from '../entities/PqrFormLaw.entity';


@Injectable({
    providedIn:'root'
})
export class pqrFormLawService{
    
    private url:string;

    constructor(private http:HttpClient){
        this.url=environment.api;
    }
    public create(PqrFormLawEntity:PqrFormLawEntity,countryId:number):Observable<ResponseModel>{
        var headers = new HttpHeaders().set('content-Type', 'application/json');
        return this.http.post<ResponseModel>(this.url+'PqrFormLawS/create/'+countryId,JSON.stringify(PqrFormLawEntity),{headers:headers});
    }
    public update(PqrFormLawEntity:PqrFormLawEntity):Observable<ResponseModel>{
        var headers = new HttpHeaders().set('content-Type', 'application/json');
        return this.http.put<ResponseModel>(this.url+'PqrFormLawS/update',JSON.stringify(PqrFormLawEntity),{headers:headers});
    }
    
    public delete(id:number):Observable<ResponseModel>{
        var headers = new HttpHeaders().set('content-Type', 'application/x-www-form-urlencoded');
        return this.http.delete<ResponseModel>(this.url+'PqrFormLawS/delete/'+id,{headers:headers});
    }
    
    public list(countryId:number):Observable<ResponseModel>{
        var headers = new HttpHeaders().set('content-Type', 'application/json');
        return this.http.get<ResponseModel>(this.url+'PqrFormLawS/list/'+countryId,{headers:headers});
    }
    public findById(id:number):Observable<ResponseModel>{
        var headers = new HttpHeaders().set('content-Type', 'application/x-www-form-urlencoded');
        return this.http.get<ResponseModel>(this.url+'PqrFormLawS/findById/'+id,{headers:headers});
    }
    public findByUserId(id:number):Observable<ResponseModel>{
        var headers = new HttpHeaders().set('content-Type', 'application/x-www-form-urlencoded');
        return this.http.get<ResponseModel>(this.url+'PqrFormLawS/findByUserId/'+id,{headers:headers});
    }
   
}